import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { RewardsGuideComponent } from '../rewards-guide/rewards-guide.component';
import { LanguageService } from 'src/app/service/language-service/language.service';
import { AnimationOptions } from 'ngx-lottie';
import { LottieService } from 'src/app/service/animations/lottie.service';

@Component({
  selector: 'app-coin-counter-modal',
  templateUrl: './coin-counter-modal.component.html',
  styleUrls: ['./coin-counter-modal.component.scss'],
})
export class CoinCounterModalComponent implements OnInit {
  @Input() coinsCustomImage: string = '';
  @Input() currencyName: string = '';
  @Input() totalCoins: number;
  language: string = 'es';
  translations;
  coinJumpOptions: AnimationOptions | null = null;

  constructor(
    private modalCtrl: ModalController,
    public router: Router,
    private languageService: LanguageService,
    private lottieService: LottieService
  ) {}

  ngOnInit() {
    this.subLanguageConfig();
    this.coinJumpOptions = this.lottieService._coinJumpOptions;
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  goToBenefits() {
    this.goToPage('beneficios');
    this.closeModal();
  }
  goToCoinsTracking() {
    this.goToPage('historial-monedas');
    this.closeModal();
  }

  goToPage(route) {
    this.router.navigate([`${route}`]);
  }

  async displayRewardsGuide() {
    this.closeModal();
    const modalAvailable = await this.modalCtrl.create({
      component: RewardsGuideComponent,
      backdropDismiss: false,
      cssClass: 'basic-modal',
      componentProps: {
        // customStyle: "",
        // projectedContent: this.coinCounterModalContent,
        // notClose: true
      },
    });
    await modalAvailable.present();
    const { data } = await modalAvailable.onWillDismiss();
    if (data === 'goToBenefits') {
      this.goToBenefits();
    }
  }

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe((lang) => {
      this.language = lang;
      this.languageService.getRewardTranslateFile(this.language).subscribe({
        next: (data) => {
          this.translations = data;
        },
        error: (e) => {
          console.log(e);
        },
      });
    });
  }
}
